import { useState } from 'react';
import DutiesAcknowledgment from "../../components/DutiesAcknowledgment";
import { Outlet } from 'react-router-dom';
// @mui
import { styled } from '@mui/material/styles';
//
import Header from './header';
import Nav from './nav';
import OnboardingTutorial from '../../components/Onboarding/OnboardingTutorial';
import TrialBanner from '../../components/TrialBanner';

// ─────────────────────────────────────────────────────────────────────────────

const APP_BAR_MOBILE = 56;
const APP_BAR_DESKTOP = 64;

const StyledRoot = styled('div')({
  display: 'flex',
  minHeight: '100%',
  overflow: 'hidden',
});

const Main = styled('div')(({ theme }) => ({
  flexGrow: 1,
  overflow: 'auto',
  minHeight: '100%',
  paddingTop: APP_BAR_MOBILE + 16,
  paddingBottom: theme.spacing(10),
  backgroundColor: 'transparent',
  [theme.breakpoints.up('lg')]: {
    paddingTop: APP_BAR_DESKTOP + 16,
    paddingLeft: theme.spacing(3),
    paddingRight: theme.spacing(3),
  },
}));

// ----------------------------------------------------------------------

export default function DashboardLayout() {
  const [open, setOpen] = useState(false);

  return (
    <StyledRoot>
      <Header onOpenNav={() => setOpen(true)} />

      <Nav openNav={open} onCloseNav={() => setOpen(false)} />

      <Main>
        <TrialBanner />
        <Outlet />
        <DutiesAcknowledgment />
      </Main>

      <OnboardingTutorial />
    </StyledRoot>
  );
}
